import reducer from './reducers';
import * as waterfallAnalysesActions from './actions';
import * as waterfallAnalysesSelectors from './selectors';

export { waterfallAnalysesActions, waterfallAnalysesSelectors };
export default reducer;
